import { useState } from "react";
import { UserGroupIcon } from "@heroicons/react/24/outline";
import { UserGroupFragment } from "../../__generated__/graphql";
import { useUser } from "../../contexts/UserContext/hooks/useUser";
import UserGroupModal from "../../pages/projects/pages/project/components/ProjectParticipants/components/UserGroupModal";

interface ClickableGroupBadgeProps {
  userGroup: UserGroupFragment;
  showMemberCount?: boolean;
  className?: string;
  projectId?: string;
  eventId?: string;
  onGroupUpdated?: () => void;
}

export default function ClickableGroupBadge({
  userGroup,
  showMemberCount = true,
  className = "",
  projectId,
  eventId,
  onGroupUpdated,
}: ClickableGroupBadgeProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { currentOrganization } = useUser();

  // User can edit if they're in the same organization that created the group
  const canEdit = currentOrganization?.id === userGroup.organizationId;

  return (
    <>
      <UserGroupModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        userGroup={userGroup}
        readOnly={!canEdit}
        projectId={projectId ?? userGroup.projectId ?? undefined}
        eventId={eventId ?? userGroup.eventId ?? undefined}
        onGroupUpdated={onGroupUpdated}
      />

      <button
        type="button"
        onClick={() => setIsModalOpen(true)}
        className={`flex items-center gap-1.5 px-3 py-1.5 bg-accent/10 border border-accent/30 rounded-full text-sm hover:bg-accent/20 hover:border-accent/50 transition-colors cursor-pointer ${className}`}
      >
        <UserGroupIcon className="w-4 h-4 text-accent" />
        <span className="text-primary font-medium">{userGroup.name}</span>
        {showMemberCount && (
          <span className="text-tertiary text-xs">
            ({userGroup.members?.length ?? 0})
          </span>
        )}
      </button>
    </>
  );
}
